import updateOrderItemImage from './updateOrderItemImage'
import validateImage from './validateImage'

const manageImageChange = async ({
  event,
  setImgErrorMessage,
  setDisplayImgUploadError,
  showErrorMessage,
  formFile,
  allowImg,
  reduceImageResolution,
  getBase64,
  setImgSteps,
  removedReqSel,
  setReqElem,
  orderItems,
  oidIndex,
  productImagesTypes,
  setUploadPayload,
  putSignedUrl,
  applicationData,
  setSelectedImages,
  setFilesUpload,
  setFormFile,
  fileUpload,
  filesUpload,
  setFileUpload,
}) => {
  const { target } = event
  const maxSize = 100000000
  const compressMaxSize = 12000000
  const idealImageSize = 2000000 // 2MB
  try {
    const files = { ...formFile }
    const sku = target.name
    const content = target.files[0]

    const {
      image,
      errorMessage,
      fileSize,
    } = await validateImage({
      content,
      maxSize,
      setImgErrorMessage,
      setDisplayImgUploadError,
      showErrorMessage,
      allowImg,
      idealImageSize,
      reduceImageResolution,
      compressMaxSize,
      getBase64,
    })

    if (errorMessage !== '') {
      throw new Error(errorMessage)
    }

    Object.assign(files, {
      [target.id]: {
        id: target.id,
        encoding: 'base64',
        file: `data:${content.type};base64,${image}`,
        decodedFile: atob(image),
        type: content.type,
        size: fileSize,
        content,
      },
    })

    const imageData = {
      id: target.id,
      type: content.type,
    }

    const required = target.attributes.getNamedItem('widgetreq').value || false

    setImgSteps(prev => {
      const updateSteps = {
        ...prev,
        [sku]: [
          ...(prev[`${sku}`] || []).filter(x => x.id !== target.id) || [],
          { id: target.id, type: content.type },
        ],
      }

      if ((updateSteps[`${sku}`] || []).length >= 1 || !required) {
        removedReqSel('productImages')
      } else if ((updateSteps[`${sku}`] || []).length < 1 && required) {
        setReqElem(previous => [...previous.filter(x => x.id !== 'productImages'), productImagesTypes])
      }

      updateOrderItemImage({
        orderItems,
        oidIndex,
        sku,
        content,
        target,
      })

      const payload = setUploadPayload(orderItems, applicationData, 'image', imageData, sku)
      putSignedUrl(payload).then(res => {
        const newUploadFilePayload = { ...fileUpload }
        Object.assign(newUploadFilePayload, {
          [sku]: {
            ...newUploadFilePayload[`${sku}`] || {},
            [target.id]: res,
          },
        })

        setSelectedImages(prev2 => ({ ...prev2, [sku]: files }))
        setFilesUpload(prev2 => ({
          ...prev2,
          [sku]: {
            ...filesUpload[`${sku}`] || {},
            [target.id]: res,
          },
        }))

        setFormFile(files)
        setFileUpload(newUploadFilePayload)
      })

      return updateSteps
    })
  } catch (error) {
    delete target.value
  }
}

export default manageImageChange
